import { IModel, Model } from '@common/models/Model';

export interface IPetCustomReminderModel extends IModel {
  petCustomReminderId: number;
  petId: number;
  salesItemName: string;
  reminded: boolean;
  dueDate: string;
  givenDate: string;
  salesItemOptionId: number;
  salesItemId: number;
  reminderSourceId: number;
  reminderDays: number;
  //UI Prop
  reminderSourceName: string;
  attachmentStorageContent: FileList;
  notes: string;
  isInactive: boolean;
  reminderDeactivationReasonId: number | undefined;
  reminderDeactivationNote: string;
}

export class PetCustomReminderModel
  extends Model
  implements IPetCustomReminderModel
{
  petCustomReminderId: number;
  petId: number;
  salesItemName: string;
  reminded: boolean;
  dueDate: string;
  givenDate: string;
  salesItemId: number;
  salesItemOptionId: number;
  reminderSourceId: number;
  reminderDays: number;
  reminderSourceName: string;
  attachmentStorageContent: FileList;
  notes: string;
  isInactive: boolean;
  reminderDeactivationReasonId: number | undefined;
  reminderDeactivationNote: string;

  constructor(params: IPetCustomReminderModel) {
    super(params);

    this.petCustomReminderId = _.defaultTo(params.petCustomReminderId, 0);
    this.petId = _.defaultTo(params.petId, 0);
    this.salesItemName = _.defaultTo(params.salesItemName, '');
    this.reminded = _.defaultTo(params.reminded, false);
    this.dueDate = _.defaultTo(params.dueDate, '');
    this.givenDate = _.defaultTo(params.givenDate, '');
    this.salesItemId = _.defaultTo(params.salesItemId, 0);
    this.salesItemOptionId = _.defaultTo(params.salesItemOptionId, 0);
    this.reminderSourceId = _.defaultTo(params.reminderSourceId, 0);
    this.reminderDays = _.defaultTo(params.reminderDays, 0);
    this.reminderSourceName = _.defaultTo(params.reminderSourceName, '');
    this.attachmentStorageContent = _.defaultTo(
      params.attachmentStorageContent,
      [] as unknown as FileList,
    );
    this.notes = _.defaultTo(params.notes, '');
    this.isInactive = _.defaultTo(params.isInactive, false);
    this.reminderDeactivationReasonId = _.defaultTo(
      params.reminderDeactivationReasonId,
      undefined,
    );
    this.reminderDeactivationNote = _.defaultTo(
      params.reminderDeactivationNote,
      '',
    );
  }
}
